export const CREDIT_CARD_BASE_URL = '/credit-card';
export const ONBOARDING_BASE_URL = `${CREDIT_CARD_BASE_URL}/onboarding`;
export const ACCOUNT_CONFIRMATION_URL = `${CREDIT_CARD_BASE_URL}/account-confirmed/`;
export const ONBOARDING_PATHS = {
    ONBOARDING_CHECKS: `${ONBOARDING_BASE_URL}/checks/`,
    ONBOARDING_DOCUMENTS: `${ONBOARDING_BASE_URL}/documents/`,
    ONBOARDING_PAYMENT_METHOD: `${ONBOARDING_BASE_URL}/payment-method/`,
    ONBOARDING_SHAREHOLDERS: `${ONBOARDING_BASE_URL}/shareholders/`,
    ONBOARDING_DELIVERY_ADDRESS: `${ONBOARDING_BASE_URL}/card-delivery/`,
    ONBOARDING_ID_CHECK: `${ONBOARDING_BASE_URL}/id-check/`,
    ONBOARDING_COMPLETE: `${ONBOARDING_BASE_URL}/complete/`
};
export const PREFERENCES_URL = `${CREDIT_CARD_BASE_URL}/preferences/`;
export const CONSENT_REVIEW_URL = `${CREDIT_CARD_BASE_URL}/consent-review/`;
export const CARD_DELIVERY_TIME_DAYS = 5;
